import { X, User, Shield, Building2, Settings, LogOut, Award, Target, Users, Languages } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

function MobileSidebar({ isOpen, onClose, user, profile, onLogout }) {
    const { language, toggleLanguage } = useLanguage();
    if (!isOpen) return null;

    return (
        <>
            {/* Backdrop overlay */}
            <div
                className="mobile-sidebar-overlay"
                onClick={onClose}
            />

            {/* Drawer */}
            <div className={`mobile-sidebar-drawer ${isOpen ? 'open' : ''}`}>
                <div style={{ padding: '1.5rem', borderBottom: '1px solid var(--glass-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                        <Link to={`/profile/${user.id}`} onClick={onClose} style={{ textDecoration: 'none' }}>
                            <div style={{
                                width: '56px', height: '56px', borderRadius: '16px',
                                border: '2px solid var(--accent-primary)', overflow: 'hidden',
                                marginBottom: '1rem'
                            }}>
                                {profile?.avatar_url ? (
                                    <img src={profile.avatar_url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                ) : (
                                    <div style={{ width: '100%', height: '100%', background: 'var(--bg-deep)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, color: 'var(--accent-primary)', fontSize: '1.2rem' }}>
                                        {user?.username?.[0]?.toUpperCase()}
                                    </div>
                                )}
                            </div>
                            <h3 style={{ fontSize: '1.1rem', fontWeight: 800, color: 'var(--text-heading)', margin: 0 }}>
                                {profile?.full_name || user?.username}
                            </h3>
                            <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)', margin: '0.2rem 0 0 0' }}>
                                {profile?.headline || profile?.role_title || 'AP NEO Member'}
                            </p>
                        </Link>
                    </div>
                    <button onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'var(--text-muted)', padding: '0.5rem' }}>
                        <X size={24} />
                    </button>
                </div>

                {/* User Stats Snapshot */}
                {profile && (
                    <div style={{ padding: '1rem 1.5rem', borderBottom: '1px solid var(--glass-border)' }}>
                        <div className="mobile-sidebar-stat-row">
                            <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Network Level</span>
                            <span style={{ color: 'var(--accent-cyan)', fontWeight: 800, fontSize: '0.85rem' }}>
                                <Award size={14} style={{ display: 'inline', marginRight: '4px', verticalAlign: 'middle' }} />
                                {profile.level || 'Initiate'}
                            </span>
                        </div>
                        {profile.points !== undefined && (
                            <div className="mobile-sidebar-stat-row">
                                <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Influence Points</span>
                                <span style={{ color: 'var(--accent-primary)', fontWeight: 800, fontSize: '0.85rem' }}>
                                    <Target size={14} style={{ display: 'inline', marginRight: '4px', verticalAlign: 'middle' }} />
                                    {profile.points}
                                </span>
                            </div>
                        )}
                        <div className="mobile-sidebar-stat-row">
                            <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Connections</span>
                            <span style={{ color: 'var(--text-heading)', fontWeight: 700, fontSize: '0.85rem' }}>
                                <Users size={14} style={{ display: 'inline', marginRight: '4px', verticalAlign: 'middle' }} />
                                {profile.connections_count || 0}
                            </span>
                        </div>
                    </div>
                )}

                <div style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <Link
                        to={`/profile/${user.id}`}
                        onClick={onClose}
                        className="mobile-sidebar-link"
                    >
                        <User size={20} /> View Profile
                    </Link>

                    {/* If the user is associated with a company, show it */}
                    {user?.company_id && (
                        <Link
                            to={`/company/${user.company_id}`}
                            onClick={onClose}
                            className="mobile-sidebar-link"
                        >
                            <Building2 size={20} /> My Company
                        </Link>
                    )}

                    {user?.role === 'ap_admin' && (
                        <Link
                            to="/admin"
                            onClick={onClose}
                            className="mobile-sidebar-link"
                        >
                            <Shield size={20} /> Admin Dashboard
                        </Link>
                    )}

                    <div style={{ margin: '1rem 0', borderTop: '1px solid var(--glass-border)' }}></div>

                    <Link
                        to="/settings"
                        onClick={onClose}
                        className="mobile-sidebar-link disabled"
                    >
                        <Settings size={20} /> Settings
                    </Link>

                    <div
                      onClick={toggleLanguage}
                      className="mobile-sidebar-link"
                      style={{ cursor: 'pointer' }}
                    >
                        <Languages size={20} />
                        <span style={{ flex: 1 }}>{language === 'en' ? 'Switch to Greek' : 'Αλλαγή σε Αγγλικά'}</span>
                        <span style={{ fontSize: '0.7rem', fontWeight: 900, background: 'rgba(99, 102, 241, 0.1)', padding: '2px 6px', borderRadius: '4px', color: 'var(--accent-primary)' }}>
                          {language === 'en' ? 'EN' : 'ΕΛ'}
                        </span>
                    </div>
                </div>

                <div style={{ marginTop: 'auto', padding: '1.5rem', borderTop: '1px solid var(--glass-border)' }}>
                    <button
                        onClick={() => { onClose(); onLogout(); }}
                        style={{
                            width: '100%', padding: '1rem', display: 'flex', alignItems: 'center', gap: '0.75rem',
                            background: 'rgba(244, 114, 182, 0.1)', color: 'var(--accent-magenta)',
                            border: '1px solid rgba(244, 114, 182, 0.2)', borderRadius: '14px',
                            fontSize: '1rem', fontWeight: 700, cursor: 'pointer'
                        }}
                    >
                        <LogOut size={20} /> Sign Out
                    </button>
                </div>
            </div>
        </>
    );
}

export default MobileSidebar;
